export default __webpack_public_path__ + "static/media/ico_programs.b2767673.svg";